import { render, staticRenderFns } from "./EnvelopIcon.vue?vue&type=template&id=0c13f68a&scoped=true&"
import script from "./EnvelopIcon.vue?vue&type=script&lang=ts&"
export * from "./EnvelopIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13f68a",
  null
  
)

export default component.exports